
import EditableToggleBlock from '@/components/EditableToggleBlock.vue'
import FileDrop from '@/components/FileDrop.vue'
import { CtAsset } from '@/models/interfaces/content-type'
import { UUID } from '@Protium/vue-ozone-utils'
import { defineComponent, onMounted, ref, watch } from 'vue'
import { useStore } from 'vuex'

type ImageData = { data: string }

export default defineComponent({
  name: 'PrintPackingSlips',
  components: { FileDrop, EditableToggleBlock },

  props: {
    catalogue: {
      type: Object
    },
    readonly: {
      type: Boolean
    }
  },
  setup (props) {
    const $store = useStore()
    const $directr = $store.getters['Services/Directr']
    const selectedImage = ref<number>(0)
    const images = ref<Record<UUID, Array<CtAsset | string>>>({})

    async function fileHandler (data) {
      // pass
      const catalogue = props.catalogue
      if (!data.fileName || !data.file || !catalogue) return
      const { items: [asset] }: { items: Array<CtAsset> } = await $directr.post('asset', 'asset.catalogue.image', { fileName: data.fileName, file: data.file })
      catalogue.packing_slip = { logo: asset.sys.id }

      void $directr.put(catalogue.sys.id, catalogue)
      const { items: [img] }: { items: Array<ImageData> } = await $directr.get('asset.catalogue.image', asset.sys.id)

      if (!img?.data) return
      if (!images.value[catalogue.sys.id]) images.value[catalogue.sys.id] = [img.data]
      else images.value[catalogue.sys.id].push(img.data)

    }

    onMounted(() => {
      void resolveImages()
    })

    watch(() => props?.catalogue, newValue => { void resolveImages() })

    async function resolveImages () {
      const id = props.catalogue?.sys?.id
      if (!id || !props.catalogue.packing_slip?.logo) return

      if (!images.value[id]) images.value[id] = []
      if (!props.catalogue.packing_slip.logo) return

      // LEGACY simply return for url arrays
      if (typeof props.catalogue.packing_slip?.logo === 'string' && props.catalogue.packing_slip?.logo.startsWith('http')) return images.value[id] = props.catalogue.packing_slip.logo

      const { items: imgs } = await $directr.get('asset.catalogue.image', props.catalogue.packing_slip.logo)

      images.value[id] = imgs.map(i => i?.data).filter(f => !!f)
    }

    return {
      fileHandler,
      images,
      selectedImage,
      resolveImages
    }
  }
})
